/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-pascal-case */
/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useState, useEffect, useRef } from "react";
import Axios from "axios";
import Form from "react-bootstrap/Form";
import bg from "../img/bg.png";
import "./PageLogin.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../components/style.css";
import ModalSign from "../components/ModalSign";
import Swal from "sweetalert2";
import {
  FaArrowAltCircleLeft,
  FaCheckCircle,
  FaTimesCircle,
  FaExclamationCircle,
  FaFileExcel,
  FaTrash,
  FaCamera,
} from "react-icons/fa";
import { Table } from "react-bootstrap";
import ModalAbsent from "../components/ModalAbsent";
import LoadingPage from "../components/LoadingPage";
import ModalExportQR from "../components/ModalExportQR";
import ModalFormRisk_level from "../components/ModalFormRisk_level";
import Spinner from "react-bootstrap/Spinner";
import { Button } from "react-bootstrap";
import {
  scrollToElement,
  adjustTableWidths,
  thai_date,
  checkGroupsUser,
  getlocalStorage,
  showLoading,
  hideLoading,
  handleResizeDisplay,
  convertTimeStringToSeconds,
} from "../function/functionALL";
// import ModalPagination from "../components/ModalPagination";
import LoadingTable from "../components/LoadingTable";
import CheckNoContent from "../components/CheckNoContent";
import Layout from "../components/Layout";
import Pagination from "react-bootstrap/Pagination";
import ModalPagination from "../components/ModalPagination";
require("moment/locale/th");

const PageTestRound = () => {
  const location = useLocation();
  const props_RoundTest = location.state || {};
  const data = props_RoundTest.RoundTest || props_RoundTest.props_RoundTest;
  const txt_search = "" || props_RoundTest.txt_search;
  const { round, id, budget_year, date, status } = data;
  const {
    Recorder_fullname,
    Id,
    Budget_year,
    DateTest,
    Num_participant,
    unit_name,
    Num_register,
    Num_test,
  } = props_RoundTest;
  const navigate = useNavigate();
  const [Test, setTest] = useState([]);
  const [numberUser, setnumberUser] = useState([]);

  const [AmoutData, setAmoutData] = useState();
  // const [pops_PageNumber, setpops_PageNumber] = useState("");
  const [pageNumber, setPageNumber] = useState(props_RoundTest.props_pageNumber || 1);
  const windowWidthRef = useRef(null);
  const [isStacked, setIsStacked] = useState(false);
  const [loadingpage, setLoadingpage] = useState(true);
  const [loadingdownload, setloadingdownload] = useState(false);
  const [search, setSearch] = useState("" || txt_search);
  const [loadingSearch, setLoadingSearch] = useState(false);
  // const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const { Token, DataToken_ } = getlocalStorage();
  const role = checkGroupsUser(DataToken_.groups);
  const role_openRole = role?.openRole;
  const userFullname = DataToken_.full_name;
  const userRankAbv = DataToken_.rank_abv;
  const userGroups = DataToken_?.groups;
  const topRef = useRef(null);
  const [loadingTable, setloadingTable] = useState(true); ////ทำงาน
  const [checkstatus, setcheckstatus] = useState([]);
  // const [stateSwitch, setSwitch] = useState(false);
  const [selectedTester, setSelectedTester] = useState(null);
  const [choiced, setChoice] = useState([]);
  const [chkEmpty, setChkEmpty] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpenAbsent, setIsModalOpenAbsent] = useState(false);
  const openModal = (Tester) => {
    setSelectedTester(Tester);
    setIsModalOpen(true);
  };

  const escapeRegExp = (s) => s?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&") ?? "";
  const deriveNameWithoutRank = (fullName, rankAbv) => {
    if (!fullName) return "";
    const original = (rankAbv || "").trim();
    // Exceptions: do NOT normalize "(พ)" or map these ranks before stripping
    const exceptions = new Set(["น.อ.(พ) หญิง", "พ.อ.อ.(พ) หญิง"]);
    if (original) {
      let toStrip = original;
      if (!exceptions.has(original)) {
        // 1) Remove "(พ)" marker before stripping
        toStrip = toStrip.replace(/\(พ\)/g, "").trim();
        // 2-7) Replace specific long-form ranks with standard honorifics
        const replacements = {
          "พนง.อาวุโสหญิง": "น.ส.",
          "พนง.อาวุโส": "นาย",
          "พนง.หญิง": "น.ส.",
          "พนง.": "นาย",
          "กห.ป.หญิง": "น.ส.",
          "กห.ส.หญิง": "น.ส.",
          "กห.ป.": "นาย",
          "กห.ส.": "นาย",
        };
        if (replacements[toStrip]) {
          toStrip = replacements[toStrip];
        }
      }
      // Strip the (possibly replaced) rank/honorific from the start of fullName
      if (toStrip) {
        const re = new RegExp("^" + escapeRegExp(toStrip));
        const stripped = fullName.replace(re, "").replace(/^[\s.\-]+/, "");
        return stripped.trim();
      }
    }
    // Fallback: remove up to last dot when rankAbv missing
    const lastDot = fullName.lastIndexOf(".");
    const stripped = lastDot >= 0 ? fullName.slice(lastDot + 1) : fullName;
    return stripped.trim();
  };

  useEffect(() => {
    if (txt_search) {
      setDataSearch();
    } else {
      // On initial load: show current user's data by searching name without rank
      const nameNoRank = deriveNameWithoutRank(userFullname, userRankAbv);
      if (nameNoRank) {
        setDataSearch(1, nameNoRank);
      } else {
        setLoadingpage(false);
        setloadingTable(false);
        setTest([]);
        setAmoutData(0);
      }
    }
    handleResizeDisplay(setIsStacked);
  }, []);

  // console.log("database: ", Test);

  const handleToggle = async (event, id) => {
    const isChecked = event.target.checked;
    // console.log("toggle pause: ", isChecked);

    await Axios.patch(
      process.env.REACT_APP_API_TESTRESULT + `${id}/`,
      {
        is_air_worker: isChecked,
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        const data = JSON.stringify(res);
        const result = JSON.parse(data);
        if (result.status === 200 || result.statusText === "OK") {
          if (txt_search || search) {
            setDataSearch(pageNumber);
          }
        }
        // setDataTest();
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.log("Error: ", err);
        Swal.fire({
          icon: "error",
          title: "Update ไม่สำเร็จ!",
        });
      });
  };

  const setDataTest = async () => {
    try {
      setloadingTable(true);
      const res = await Axios.get(
        process.env.REACT_APP_API_TESTROUND + `${Id || id}/`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );
      setcheckstatus(res.data.status);
      // console.log("respone: ", res.data.participant_list);
      setTest(res.data.participant_list);
      setnumberUser(res.data);
      setAmoutData(res.data.num_participant);
      setloadingTable(false);
    } catch (err) {
      if (err.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      }
      console.error(err);
      Swal.fire({
        icon: "error",
      });
    }
  };

  const setDataSearch = async (page = 1, query) => {
    try {
      setLoadingSearch(true);
      const q = query ?? search;
      if (query !== undefined) {
        setSearch(String(q));
      }

      const response = await Axios.get(
        process.env.REACT_APP_API_TESTROUND +
          `${Id || id}/?search=${encodeURIComponent(q)}&page=${page}`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
        }
      );
      
      const rows = response.data.participant_list || [];
      if (rows.length === 0) {
        const nameNoRank = deriveNameWithoutRank(userFullname, userRankAbv);
        if (nameNoRank && q !== nameNoRank) {
          // fallback to current user's name
          await setDataSearch(page, nameNoRank);
          return;
        }
      }
      setTest(rows);
      // paginate count based on participant_list length
      setAmoutData(rows.length);
      // console.log("respone: ", response.data.participant_list.is_air_worker);
      setLoadingSearch(false);
      setLoadingpage(false);
      setloadingTable(false);
      // setSwitch(true);

      // }
    } catch (err) {
      if (err.response && err.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      } else if (err.response && err.response.status === 404) {
        const nameNoRank = deriveNameWithoutRank(userFullname, userRankAbv);
        if (nameNoRank && (query ?? search) !== nameNoRank) {
          await setDataSearch(page, nameNoRank);
          return;
        }
        setTest([]);
        setLoadingSearch(false);
        setLoadingpage(false);
      } else {
        console.error(err);
        Swal.fire({
          icon: "warning",
          title: err.response ? err.response.data.detail : "An error occurred",
        });
      }
    }
  };

  const handleload_excel = async () => {
    setloadingdownload(true);
    try {
      const response = await Axios.get(
        process.env.REACT_APP_API_TESTROUND + `${Id || id}/load_excel/`,
        {
          headers: {
            Authorization: "Token " + Token,
          },
          responseType: "blob",
        }
      );
      const budgetYear = Budget_year || budget_year;
      const fileName = `รายงานผลปีงบประมาณ ${budgetYear}-${round}.xlsx`;

      const url = URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();

      setloadingdownload(false);
      Swal.fire({
        icon: "success",
        title: "Export Excel สำเร็จ!",
      });
    } catch (error) {
      if (error.response.status === 401) {
        localStorage.removeItem("Token_");
        localStorage.removeItem("Token");
        navigate("/notfound404");
      }
      console.error("Error downloading file:", error);
      Swal.fire({
        icon: "error",
        title: "Export Excel ไม่สำเร็จ!",
      });
    }
  };

  const searchValue = async (e) => {
    e.preventDefault();

    if (search?.length >= 3) {
      setDataSearch(1, search);
    } else {
      const nameNoRank = deriveNameWithoutRank(userFullname, userRankAbv);
      if (nameNoRank) {
        setDataSearch(1, nameNoRank);
      } else {
        Swal.fire({
          icon: "warning",
          title: "กรุณาค้นหา 3 ตัวอักษรขึ้นไป",
        });
      }
    }
  };

  const handleChangeSearch = async (e) => {
    const txt = await e.target.value;
    // console.log("txt", txt);
    if (txt === "") {
      // When cleared, show current user's data by nameNoRank
      const nameNoRank = deriveNameWithoutRank(userFullname, userRankAbv);
      setSearch("");
      setPageNumber(1);
      if (nameNoRank) {
        setDataSearch(1, nameNoRank);
      } else {
        setTest([]);
        setAmoutData(0);
        setloadingTable(false);
        setLoadingpage(false);
      }
    } else {
      setSearch(txt);
    }
  };

  const AmountPage = Math.ceil(AmoutData / 25);

  const handlePageChange = (pageNumber) => {
    setPageNumber(pageNumber);
    scrollToElement(topRef);
    if (search || txt_search) {
      setloadingTable(true);
      setDataSearch(pageNumber);
    } else {
      // No full list paging
      setloadingTable(false);
    }
  };

  const loadDataChangePage = (pageNumber) => {
    // Only fetch during search mode
    if (search || txt_search) {
      setDataSearch(pageNumber);
    }
  };

  const checkUser = (id) => {
    console.log("checkUser id: ", id);
    // setloadingTable(true)
    Axios.patch(
      process.env.REACT_APP_API_TESTRESULT + `${id}/`,
      {
        status: "1",
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        const data = JSON.stringify(res);
        const result = JSON.parse(data);
        if (result.status === 200 || result.statusText === "OK") {
          Swal.fire({
            icon: "success",
            title: "ลงชื่อสำเร็จ!",
          });
          if (txt_search || search) {
            setDataSearch();
          } else {
            loadDataChangePage(pageNumber);
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };

  // User right filter only user data
  if (userGroups.length === 0) {
    for (let i = Test.length - 1; i >= 0; i--) {
      if (Test[i].tester_fullname !== userFullname) {
        Test.splice(i, 1);
      }
    }
  }

  const confirmDelete = (id) => {
    Swal.fire({
      title: "ยืนยันการลบ",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      cancelButtonText: "ยกเลิก",
      confirmButtonColor: "#3085d6",
      confirmButtonText: "ยืนยันการลบ",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDelete(id);
      }
    });
  };
  //Delete user id in table
  const handleDelete = (id) => {
    Axios.delete(process.env.REACT_APP_API_TESTRESULT + `${id}/`, {
      headers: {
        Authorization: "Token " + Token,
      },
    })
      .then((res) => {
        Swal.fire({
          icon: "success",
          title: "ลบข้อมูลสำเร็จ",
        });
        // setDataTest();
        // setDataSearch();
        navigate(0);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };

  const openModelAbsent = (Tester) => {
    setSelectedTester(Tester);
    setIsModalOpenAbsent(true);
  };

  const handleSave = (result, Tester) => {
    Axios.patch(
      process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`,
      {
        body_data: result.body_data,
      },
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        // console.log("Success update: ", res.data.message);
        // console.log("Success: ", res);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("DataLogin");
          navigate(
            "/notfound404"
            // { state: {statusCode: err.response.status, txt: err.response.data} }
          );
        }
        console.error(err);
      });
    Axios.post(
      process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/add_answer/`,
      result.data,
      {
        headers: {
          Authorization: "Token " + Token,
        },
      }
    )
      .then((res) => {
        const data = JSON.stringify(res);
        const result = JSON.parse(data);
        if (result.status === 200 || result.statusText === "OK") {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ!",
          }).then((result) => {
            setChoice([]);
            setIsModalOpen(false);
            setSelectedTester(null);
            setChkEmpty(true);
            if (txt_search || search) {
              setDataSearch();
            } else {
              loadDataChangePage(pageNumber);
            }
          });
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("id");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
      });
  };

  const handleSaveAbsent = (data, Tester) => {
    Axios.patch(process.env.REACT_APP_API_TESTRESULT + `${Tester.id}/`, data, {
      headers: {
        Authorization: "Token " + Token,
      },
    })
      .then((res) => {
        const data = JSON.stringify(res);
        const result = JSON.parse(data);
        if (result.status === 200 || result.statusText === "OK") {
          Swal.fire({
            icon: "success",
            title: "บันทึกข้อมูลสำเร็จ!",
          });
          setIsModalOpenAbsent(false);
          setSelectedTester(null);
          if (txt_search || search) {
            setDataSearch();
          } else {
            loadDataChangePage(pageNumber);
          }
        }
      })
      .catch((err) => {
        if (err.response.status === 401) {
          localStorage.removeItem("Token_");
          localStorage.removeItem("Token");
          navigate("/notfound404");
        }
        console.error(err);
        Swal.fire({
          icon: "error",
        });
      });
  };

  return (
    <>
      <Layout>
        <div ref={topRef}>
          <Form>
            <style>
              {`
        .mr10 {margin-right: 10px;}
      `}
            </style>
            <div className="App login-box">
              <section
                style={{
                  backgroundImage: `url(${bg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundSize: "100% 100%",
                  backgroundSize: "cover",
                  minHeight: "1180px",
                }}
              >
                <div className="mb-0 rounded" style={{ padding: "68px 0 0 0" }}>
                  <div className="row col-12 col-sm-12 ms-0 justify-content-center pt-3">
                    <div className="p-3">
                      <div
                        className="card col-sm-12 col-xs-12"
                        style={{ backgroundColor: "rgb(247, 247, 247, 0.7)" }}
                      >
                        <div className="card-body rounded">
                          <div className="row d-flex p-2 mt-2">
                            <div className="text-start col-1 col-sm-2 p-0 h-100">
                              {/* <a href="/PageHome"> */}
                              <Link
                                to={`/PageHome`}
                                style={{
                                  textDecoration: "none",
                                  color: "inherit",
                                  display: "inline-block",
                                }}
                              >
                                <button
                                  type="button"
                                  className="btn btn-primary m-0 d-none d-md-block px-4 "
                                  style={{
                                    backgroundColor: "rgb(2, 117, 216,0.80)",
                                    border: "none",
                                  }}
                                >
                                  ย้อนกลับ
                                </button>
                              </Link>{" "}
                              <Link to={`/PageHome`} className="d-md-none ">
                                <FaArrowAltCircleLeft
                                  style={{ fontSize: "22px", color: "#3399FF" }}
                                  className="mt-2 d-md-none"
                                />{" "}
                              </Link>
                              {/* </a> */}
                            </div>
                            <div
                              className=" col-10 col-sm-8 card-title text-center fs-5 fs-3 py-1"
                              style={{ color: "#000000" }}
                            >
                              <div
                                className="fw-bold"
                                style={{ fontSize: "21px" }}
                              >
                                การทดสอบสมรรถภาพทางกาย
                              </div>
                            </div>
                            <div
                              className=" col-12 col-sm-12 text-center fw-bold mb-3"
                              style={{ fontSize: "16px" }}
                            >
                              ปีงบประมาณ {Budget_year || budget_year} รอบที่{" "}
                              {round + " "}{" "}
                              {userGroups[0] === "RTAFPersonAdmin"
                                ? unit_name
                                : null}{" "}
                              {"( "}
                              {thai_date(DateTest || date, "shortdate")}
                              {" )"}
                            </div>
                            <hr></hr>
                          </div>
                          <div className="m-0 p-0">
                            <div
                              className="row d-flex justify-content-between fw-bold"
                              style={{ fontSize: "16px", color: "#616161" }}
                            >
                              <div className="row col-12 col-md-9 ms-0 ">
                                {role_openRole?.FunctionaryTester ||
                                role_openRole?.UnitAdmin ||
                                role_openRole?.RTAFPersonAdmin ? (
                                  <div className="col-12 col-md-6 col-lg-5 d-flex align-items-sm-center justify-content-center">
                                    
                                  </div>
                                ) : (
                                  ""
                                )}
                                {role_openRole?.UnitAdmin ||
                                role_openRole?.RTAFPersonAdmin ? (
                                  <div className="col-12 col-sm-12 col-md-4 mt-3 mt-sm-0 p-0 d-flex justify-content-center justify-content-md-between">
                                    {/* <RenderQRButtonModalSign /> */}
                                    <ModalSign
                                      // Tester={DataToken_}
                                      // Test={Test}
                                      Id_TestRound={Id || id}
                                      round_detail={data}
                                      // Num_register={Num_register}
                                      // Num_test={Num_test}
                                      // DateTest={DateTest}
                                      Budget_year={Budget_year}
                                      round={round}
                                      checkstatus={checkstatus}
                                      // Num_participant={Num_participant}
                                      // Recorder_fullname={Recorder_fullname}
                                      // Id_test={Id}
                                      // Risk_level={DataToken_.risk_score}
                                      // Tester_fullname={
                                      //   DataToken_.tester_fullname
                                      // }
                                      // Tester_position={
                                      //   DataToken_.tester_position
                                      // }
                                      // Tester_age={DataToken_.tester_age}
                                    />
                                    {loadingdownload ? (
                                      <Button
                                        className="btn btn-primary col-3 col-sm-3 col-md-6 col-lg-6 px-1 ms-md-2 ms-1"
                                        style={{
                                          backgroundColor:
                                            "RGB(255, 181, 69,0.90)",
                                          border: "none",
                                        }}
                                      >
                                        <Spinner
                                          as="span"
                                          variant="light"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                          animation="border"
                                        />
                                        กำลังดาวน์โหลด
                                      </Button>
                                    ) : (
                                      <Button
                                        className="btn btn-primary col-3 col-sm-3 col-md-6 col-lg-6 px-1 ms-md-2 ms-1"
                                        style={{
                                          backgroundColor: "#1c8a53",
                                          border: "none",
                                          fontSize: "13px",
                                        }}
                                        onClick={() => handleload_excel()}
                                      >
                                        Export <FaFileExcel />
                                      </Button>
                                    )}
                                    <ModalExportQR
                                      Id={Id || id}
                                      unit_name={unit_name}
                                    />
                                  </div>
                                ) : role_openRole?.FunctionaryTester ? (
                                  <div className="col-12 col-sm-12 col-md-6 mt-3 mt-sm-0 px-0  d-flex justify-content-center justify-content-md-start">
                                    {/* <RenderQRButtonModalSign /> */}
                                    <ModalSign
                                      Tester={DataToken_}
                                      Test={Test}
                                      Id_TestRound={Id || id}
                                      round_detail={data}
                                      Num_register={Num_register}
                                      Num_test={Num_test}
                                      DateTest={DateTest}
                                      Budget_year={Budget_year}
                                      round={round}
                                      Num_participant={Num_participant}
                                      Recorder_fullname={Recorder_fullname}
                                      Id_test={Id}
                                      Risk_level={DataToken_.risk_score}
                                      Tester_fullname={
                                        DataToken_.tester_fullname
                                      }
                                      Tester_position={
                                        DataToken_.tester_position
                                      }
                                      Tester_age={DataToken_.tester_age}
                                    />
                                  </div>
                                ) : null}
                              </div>

                              {role_openRole?.FunctionaryTester ||
                              role_openRole?.UnitAdmin ||
                              role_openRole?.RTAFPersonAdmin ? (
                                <div className="col-12 col-md-3 has-validation mt-2 mt-xl-0">
                                  <div className="input-group">
                                    <input
                                      className="form-control"
                                      placeholder="ค้นหา / Search"
                                      defaultValue=""
                                      onChange={(event) =>
                                        // setSearch(e.target.value)
                                        handleChangeSearch(event)
                                      }
                                    />
                                    {loadingSearch ? (
                                      <button
                                        className="input-group-text"
                                        style={{
                                          backgroundColor:
                                            "RGB(255, 181, 69,0.90)",
                                          border: "none",
                                        }}
                                      >
                                        <Spinner
                                          as="span"
                                          animation="border"
                                          variant="light"
                                          size="sm"
                                          role="status"
                                          aria-hidden="true"
                                        />
                                        กรุณารอสักครู่...
                                      </button>
                                    ) : (
                                      <button
                                        className="input-group-text"
                                        style={{
                                          backgroundColor: "#9ca0ca",
                                          fontWeight: "500",
                                        }}
                                        onClick={searchValue}
                                        // onBlur={blur}
                                      >
                                        ค้นหา
                                      </button>
                                    )}
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>

                         {/* <!-- Table  --> */}
                          {!loadingTable && Test.length === 0 ? (
                            <div
                              className="text-center text-muted mt-2 mb-2"
                              style={{
                                fontSize: " 28px",
                                background: "rgba(0,0,0,0.03)",
                                border: "1px solid rgba(0,0,0,0.06)",
                                color: "#6c757d",
                                padding: "10px 14px",
                                borderRadius: "10px",
                              }}
                            >
                              ใช้การค้นหาหรือ Scan QR เพื่อดำเนินการกรอกคะแนน
                            </div>
                          ) : null}

                          <div
                            className="table table-hover overflow-auto mt-1"
                            style={{ height: "800px" }}
                          >
                            {/* <div style={{ height: "800px" }}> */}
                            {loadingTable ? (
                              <LoadingTable />
                            ) : (
                              <Table
                                // responsive
                                className={
                                  isStacked
                                    ? "table-stacked"
                                    : "table_content table table-hover"
                                }
                                style={{
                                  backgroundColor: "rgb(247, 247, 247, 0.7)",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        textAlign: "center",
                                        width: "20%",
                                        minWidth: "200px",
                                        backgroundColor: "#666699",
                                        height: "70px",
                                        color: "white",
                                      }}
                                    >
                                      <p>ชื่อ - นามสกุล</p>
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "10%",
                                        minWidth: "150px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                        zIndex: 1,
                                      }}
                                    >
                                      <p>ผู้ปฏิบัติงาน</p>
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "10%",
                                        minWidth: "80px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                      }}
                                    >
                                      <p>การลงชื่อ</p>
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "10%",
                                        minWidth: "150px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                        verticalAlign: "middle",
                                      }}
                                    >
                                      กรณีไม่เข้ารับการทดสอบ
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "8%",
                                        minWidth: "100px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                      }}
                                    >
                                      <p>ประเมินความเสี่ยง</p>
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "8%",
                                        minWidth: "100px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                      }}
                                    >
                                      <p>ดันพื้น</p>
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "8%",
                                        minWidth: "100px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                      }}
                                    >
                                      <p>ลุกนั่ง</p>
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "8%",
                                        minWidth: "100px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                      }}
                                    >
                                      <p>เดิน/วิ่ง</p>
                                    </th>
                                    <th
                                      scope="col"
                                      style={{
                                        fontSize: "14px",
                                        width: "10%",
                                        minWidth: "100px",
                                        textAlign: "center",
                                        backgroundColor: "#8181B8",
                                        color: "white",
                                      }}
                                    >
                                      <p>การทดสอบ</p>
                                    </th>
                                    {/* {DataLogin.groups.includes("UnitAdmin") === true ?   */}

                                    {role_openRole?.UnitAdmin ||
                                    role_openRole?.RTAFPersonAdmin ? (
                                      <th
                                        scope="col"
                                        style={{
                                          fontSize: "14px",
                                          width: "10%",
                                          minWidth: "100px",
                                          textAlign: "center",
                                          backgroundColor: "#8181B8",
                                          color: "white",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        ลบออกจากวงรอบ
                                      </th>
                                    ) : (
                                      ""
                                    )}

                                    {/* :""} */}
                                  </tr>
                                </thead>
                                <tbody>
                                  {(!loadingTable && Test.length === 0)
                                    ? Array.from({ length: 6 }).map((_, i) => (
                                        <tr className="raw" key={`skeleton-${i}`}>
                                          {[20, 10, 10, 10, 8, 8, 8, 8, 10]
                                            .concat(
                                              role_openRole?.UnitAdmin ||
                                                role_openRole?.RTAFPersonAdmin
                                                ? [10]
                                                : []
                                            )
                                            .map((_, idx) => (
                                              <td key={`sk-${i}-${idx}`} style={{ verticalAlign: "middle" }}>
                                                <div
                                                  style={{
                                                    height: "14px",
                                                    width: "100%",
                                                    background:
                                                      "linear-gradient(90deg,#eeeeee 25%, #f5f5f5 37%, #eeeeee 63%)",
                                                    borderRadius: "6px",
                                                    animation: "pulse 1.2s ease-in-out infinite",
                                                  }}
                                                />
                                              </td>
                                            ))}
                                        </tr>
                                      ))
                                    : null}
                                  {Test.map((Data, i) => (
                                    <tr className="raw" key={i}>
                                      <td
                                        className="text-center text-lg-start pt-lg-3 ps-lg-2"
                                        style={{
                                          fontSize: "16px",
                                          backgroundColor: "#d0d9ff",
                                        }}
                                        data-label="ชื่อ - นามสกุล"
                                      >
                                        {(pageNumber - 1) * 25 + i++ + 1}.
                                        {Data.tester_fullname}
                                      </td>
                                      <td
                                        className="text-center"
                                        data-label="ผู้ปฏิบัติงาน"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        <div className="custom-switch ">
                                          <input
                                            type="checkbox"
                                            id={`toggle-${Data.id}`}
                                            checked={Data.is_air_worker}
                                            disabled={checkstatus === 0}
                                            // defaultChecked={
                                            //   Data.is_air_worker === true
                                            //     ? true
                                            //     : false
                                            // }
                                            onChange={(event) =>
                                              handleToggle(event, Data.id)
                                            }
                                          />
                                          <label
                                            htmlFor={`toggle-${Data.id}`}
                                            className="toggle-label"
                                          >
                                            <span
                                              className={`toggle-text ${
                                                Data.is_air_worker
                                                  ? "right-text pe-4"
                                                  : "left-text ps-4"
                                              }`}
                                            >
                                              {Data.is_air_worker
                                                ? "ภาคอากาศ"
                                                : "ภาคพื้น"}
                                            </span>
                                          </label>
                                        </div>
                                      </td>
                                      <td
                                        className="text-center"
                                        data-label="การลงชื่อ"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        <div className="d-flex justify-content-center col-12 col-lg-12 col-sm-12">
                                          {role_openRole?.UnitAdmin &&
                                          Data.status === 0 &&
                                          Data.absent_reason === 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary ms-1"
                                              onClick={() => checkUser(Data.id)}
                                              style={{
                                                width: "115px",
                                                backgroundColor:
                                                  "rgb(2, 117, 216,0.80)",
                                                border: "none",
                                              }}
                                            >
                                              ลงชื่อ
                                            </button>
                                          ) : role_openRole?.UnitAdmin &&
                                            Data.status === 1 &&
                                            Data.absent_reason === 0 ? (
                                            <div>
                                              <FaCheckCircle
                                                style={{
                                                  color:
                                                    "RGB(124, 179, 66,0.80)",
                                                }}
                                              />
                                            </div>
                                          ) : numberUser.status === 0 &&
                                            role_openRole?.FunctionaryTester &&
                                            Data.status === 0 &&
                                            Data.absent_reason === 0 ? (
                                            <div className="">
                                              <FaExclamationCircle
                                                style={{
                                                  color:
                                                    "RGB(255, 181, 69,0.90)",
                                                }}
                                              />
                                            </div>
                                          ) : role_openRole?.FunctionaryTester &&
                                            Data.status === 1 &&
                                            Data.absent_reason === 0 ? (
                                            <div>
                                              <FaCheckCircle
                                                style={{
                                                  color:
                                                    "RGB(124, 179, 66,0.80)",
                                                }}
                                              />
                                            </div>
                                          ) : numberUser.status === 1 &&
                                            role_openRole?.FunctionaryTester &&
                                            Data.status === 0 &&
                                            Data.absent_reason === 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary  ms-1"
                                              onClick={() => checkUser(Data.id)}
                                              style={{
                                                width: "115px",
                                                backgroundColor:
                                                  "rgb(2, 117, 216,0.80)",
                                                border: "none",
                                              }}
                                            >
                                              ลงชื่อ
                                            </button>
                                          ) : role_openRole?.RTAFPersonAdmin &&
                                            Data.status === 0 &&
                                            Data.absent_reason === 0 ? (
                                            <div>
                                              <FaExclamationCircle
                                                style={{
                                                  color:
                                                    "RGB(255, 181, 69,0.90)",
                                                }}
                                              />
                                            </div>
                                          ) : role_openRole?.RTAFPersonAdmin &&
                                            Data.status === 1 &&
                                            Data.absent_reason === 0 ? (
                                            <div>
                                              <FaCheckCircle
                                                style={{
                                                  color:
                                                    "RGB(124, 179, 66,0.80)",
                                                }}
                                              />
                                            </div>
                                          ) : DataToken_.groups.length === 0 &&
                                            Data.status === 1 &&
                                            Data.absent_reason === 0 ? (
                                            <div>
                                              <FaCheckCircle
                                                style={{
                                                  color:
                                                    "RGB(124, 179, 66,0.80)",
                                                }}
                                              />
                                            </div>
                                          ) : numberUser.status === 1 &&
                                            !role_openRole?.RTAFPersonAdmin &&
                                            Data.absent_reason === 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary  ms-1"
                                              onClick={() => checkUser(Data.id)}
                                              style={{
                                                width: "115px",
                                                backgroundColor:
                                                  "rgb(2, 117, 216,0.80)",
                                                border: "none",
                                              }}
                                            >
                                              ลงชื่อ
                                            </button>
                                          ) : Array.isArray(DataToken_.groups) &&
                                            DataToken_.groups.length === 0 &&
                                            Data.status === 0 &&
                                            Data.absent_reason === 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary  ms-1"
                                              onClick={() => checkUser(Data.id)}
                                              style={{
                                                width: "115px",
                                                backgroundColor:
                                                  "rgb(2, 117, 216,0.80)",
                                                border: "none",
                                              }}
                                            >
                                              ลงชื่อ
                                            </button>
                                          ) : Data.absent_reason === 1 ||
                                            Data.absent_reason === 2 ||
                                            Data.absent_reason === 3 ||
                                            Data.absent_reason === 4 ? (
                                            <div>
                                              <FaTimesCircle
                                                style={{
                                                  color: "RGB(255, 0, 0,0.60)",
                                                }}
                                              />
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                      </td>
                                      <td
                                        className="text-center"
                                        data-label="กรณีไม่ได้ทดสอบ"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        {/* <div className=""> */}
                                        <div className="text-center ms-1">
                                          <button
                                            type="button"
                                            className="btn btn-secondary"
                                            style={{
                                              backgroundColor:
                                                Data.absent_reason !== 0
                                                  ? "RGB(255, 0, 0,0.60)"
                                                  : "RGB(255, 181, 69,0.90)",
                                              // backgroundColor: "#FFB545"
                                              border: "none",
                                              width: "115px",
                                            }}
                                            onClick={() =>
                                              openModelAbsent(Data)
                                            }
                                            // onClick={handleShow}
                                          >
                                            {Data.absent_reason === 1
                                              ? "ราชการ"
                                              : Data.absent_reason === 2
                                              ? "ศึกษา"
                                              : Data.absent_reason === 3
                                              ? "ป่วย"
                                              : Data.absent_reason === 4
                                              ? "อื่นๆ"
                                              : "กรอกข้อมูล"}
                                          </button>
                                        </div>
                                        {/* <ModalAbsent
                                            ID_user={Data.id}
                                            Tester={Data}
                                            checkstatus={checkstatus}
                                          /> */}
                                        {/* </div> */}
                                      </td>

                                      <td
                                        className="text-center"
                                        data-label="ประเมินความเสี่ยง"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        {" "}
                                        <div className="text-center ms-1">
                                          <Button
                                            type="button"
                                            className="btn btn-primary"
                                            style={{
                                              width: "115px",
                                              backgroundColor:
                                                Data.risk_score === -1
                                                  ? "#FFB545"
                                                  : Data.risk_score >= 1
                                                  ? "RGB(255, 0, 0,0.60)"
                                                  : Data.risk_score === null
                                                  ? "#FFB545"
                                                  : "#7cb342",
                                              border: "none",
                                              // fontSize: "14px",
                                            }}
                                            onClick={() => openModal(Data)}
                                          >
                                            {Data.risk_score === -1
                                              ? "รอประเมิน"
                                              : Data.risk_score >= 1
                                              ? " มีความเสี่ยง"
                                              : Data.risk_score === null
                                              ? "รอประเมิน"
                                              : " ผ่าน"}
                                          </Button>
                                        </div>
                                      </td>
                                      <td
                                        className="text-center"
                                        data-label="ดันพื้น"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        {Data.pushup.quantity === -1 ? (
                                          <FaExclamationCircle
                                            style={{
                                              color: "RGB(255, 181, 69,0.90)",
                                            }}
                                          />
                                        ) : Data.pushup.quantity >=
                                          Data.pushup.pass_quantity ? (
                                          <b
                                            style={{
                                              color: "RGB(124, 179, 66,0.80)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.pushup.score} (
                                            {Data.pushup.quantity} ครั้ง)
                                          </b>
                                        ) : (
                                          <b
                                            style={{
                                              color: "RGB(255, 0, 0,0.60)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.pushup.score} (
                                            {Data.pushup.quantity} ครั้ง)
                                          </b>
                                        )}
                                      </td>
                                      <td
                                        className="text-center"
                                        data-label="ลุกนั่ง"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        {Data.situp.quantity === -1 ? (
                                          <FaExclamationCircle
                                            style={{
                                              color: "RGB(255, 181, 69,0.90)",
                                            }}
                                          />
                                        ) : Data.situp.quantity >=
                                          Data.situp.pass_quantity ? (
                                          <b
                                            style={{
                                              color: "RGB(124, 179, 66,0.80)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.situp.score} (
                                            {Data.situp.quantity} ครั้ง)
                                          </b>
                                        ) : (
                                          <b
                                            style={{
                                              color: "RGB(255, 0, 0,0.60)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.situp.score} (
                                            {Data.situp.quantity} ครั้ง)
                                          </b>
                                        )}
                                      </td>

                                      <td
                                        className="text-center"
                                        data-label="เดิน-วิ่ง"
                                        style={{ verticalAlign: "middle" }}
                                      >
                                        {Data.walk.score === -1 &&
                                        Data.run.score === -1 ? (
                                          <FaExclamationCircle
                                            style={{
                                              color: "RGB(255, 181, 69,0.90)",
                                            }}
                                          />
                                        ) : Data.walk.score !== -1 &&
                                          convertTimeStringToSeconds(
                                            Data.walk.quantity
                                          ) <=
                                            convertTimeStringToSeconds(
                                              Data.walk.pass_quantity
                                            ) ? (
                                          <b
                                            style={{
                                              color: "RGB(124, 179, 66,0.80)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.walk.score} (
                                            {Data.walk.quantity} นาที)
                                          </b>
                                        ) : Data.run.score !== -1 &&
                                          convertTimeStringToSeconds(
                                            Data.run.quantity
                                          ) <=
                                            convertTimeStringToSeconds(
                                              Data.run.pass_quantity
                                            ) ? (
                                          <b
                                            style={{
                                              color: "RGB(124, 179, 66,0.80)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.run.score} (
                                            {Data.run.quantity} นาที)
                                          </b>
                                        ) : convertTimeStringToSeconds(
                                            Data.walk.quantity
                                          ) >
                                          convertTimeStringToSeconds(
                                            Data.walk.pass_quantity
                                          ) ? (
                                          <b
                                            style={{
                                              color: "RGB(255, 0, 0,0.60)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.walk.score} (
                                            {Data.walk.quantity} นาที)
                                          </b>
                                        ) : convertTimeStringToSeconds(
                                            Data.run.quantity
                                          ) >
                                          convertTimeStringToSeconds(
                                            Data.run.pass_quantity
                                          ) ? (
                                          <b
                                            style={{
                                              color: "RGB(255, 0, 0,0.60)",
                                              fontSize: "14px",
                                            }}
                                          >
                                            {Data.run.score} (
                                            {Data.run.quantity} นาที)
                                          </b>
                                        ) : (
                                          ""
                                        )}
                                      </td>
                                      <td
                                        className="text-center"
                                        data-label="การทดสอบ"
                                      >
                                        {(Data.risk_score === -1 || Data.risk_score === null) ? (
                                          <div className="">
                                            <button
                                              type="button"
                                              className="btn btn-secondary"
                                              style={{
                                                width: "115px",
                                                background: "RGB(108, 117, 125,0.50)",
                                                border: "none",
                                                color: "white",
                                                cursor: "not-allowed",
                                                opacity: "0.6",
                                                fontSize: "12px"
                                                
                                              }}
                                              disabled
                                            >
                                              กรุณาประเมินก่อน
                                            </button>
                                          </div>
                                        ) : (
                                          <Link
                                            to={`/PageTestScore`}
                                            state={{
                                              Tester: Data,
                                              ID_user: Data.id,
                                              round_detail: data,
                                              txt_search: search,
                                              unit_name: unit_name,
                                              checkstatus: checkstatus,
                                              pageNumber: pageNumber,
                                              AmountPage: AmountPage
                                            }}
                                          >
                                            <div className="">
                                              <button
                                                type="button"
                                                className="btn btn-primary"
                                                style={{
                                                  width: "115px",
                                                  background:
                                                    "rgb(2, 117, 216,0.80)",
                                                  border: "none",
                                                }}
                                              >
                                                ผลคะแนน
                                              </button>
                                            </div>
                                          </Link>
                                        )}
                                      </td>

                                      {role_openRole?.UnitAdmin ||
                                      role_openRole?.RTAFPersonAdmin ? (
                                        <td
                                          className="text-center"
                                          data-label="ลบออกจากวงรอบ"
                                        >
                                          {status === 0 ? (
                                            <button
                                              type="button"
                                              className="btn btn-primary "
                                              style={{
                                                border: "none",
                                                backgroundColor:
                                                  "RGB(108, 117, 125,0.50)",
                                                width: "115px",
                                              }}
                                            >
                                              <FaTrash
                                                style={{
                                                  color: "white",
                                                  fontSize: "25px",
                                                }}
                                              />
                                            </button>
                                          ) : (
                                            <button
                                              type="button"
                                              className="btn btn-primary "
                                              style={{
                                                border: "none",
                                                backgroundColor:
                                                  "RGB(255, 0, 0,0.60)",
                                                width: "115px",
                                              }}
                                              onClick={() =>
                                                confirmDelete(Data.id)
                                              }
                                            >
                                              <FaTrash
                                                style={{
                                                  color: "white",
                                                  fontSize: "25px",
                                                }}
                                              />
                                            </button>
                                          )}
                                        </td>
                                      ) : (
                                        ""
                                      )}
                                    </tr>
                                  ))}
                                </tbody>
                              </Table>
                            )}
                            {/* </div> */}
                          </div>
                          

                          <ModalAbsent
                            ID_user={selectedTester?.id}
                            Tester={selectedTester}
                            checkstatus={checkstatus}
                            show={isModalOpenAbsent}
                            onClose={() => setIsModalOpenAbsent(false)}
                            onSave={handleSaveAbsent}
                          />
                          {/* <ModalSign
                          showModalSign={isModalSignOpen}
                          onSaveModalSign={handleSaveModalSign}
                          onCloseModalSign={() => setIsModalSignOpen(false)}
                          Tester={DataToken_}
                          Test={Test}
                          Id_TestRound={Id || id}
                          round_detail={data}
                          Num_register={Num_register}
                          Num_test={Num_test}
                          DateTest={DateTest}
                          Budget_year={Budget_year}
                          round={round}
                          Num_participant={Num_participant}
                          Recorder_fullname={Recorder_fullname}

                          Id_test={Id}
                          Risk_level={DataToken_.risk_score}
                          Tester_fullname={DataToken_.tester_fullname}
                          Tester_position={DataToken_.tester_position}
                          Tester_age={DataToken_.tester_age}
                          pops_UserData={pops_UserData}
                          setpops_UserData={setpops_UserData}


                        /> */}
                          <ModalFormRisk_level
                            show={isModalOpen}
                            setChoice={setChoice}
                            choiced={choiced}
                            setChkEmpty={setChkEmpty}
                            chkEmpty={chkEmpty}
                            onSave={handleSave}
                            onClose={() => setIsModalOpen(false)}
                            Tester={selectedTester}
                            round_detail={data}
                            Budget_year={Budget_year}
                            round={round}
                            DateTest={DateTest}
                            checkstatus={checkstatus}
                          />

                          {role_openRole?.RTAFPersonAdmin ||
                          role_openRole?.UnitAdmin ||
                          role_openRole?.FunctionaryTester ? (
                            <ModalPagination
                              pageNumber={pageNumber}
                              AmountPage={AmountPage}
                              handlePageChange={handlePageChange}
                            />
                          ) : (
                            // <Pagination className="p-0 justify-content-center">
                            //   {renderPageNumbers()}
                            // </Pagination>
                            ""
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div></div>
                </div>
              </section>
            </div>
          </Form>
        </div>
      </Layout>
    </>
  );
};

export default PageTestRound;
